var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardCloudIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 119,
    viewBox: "0 0 191 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_157_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.119 36.7936C138.509 38.0907 145.021 41.4374 149.412 46.1955C153.803 50.9536 155.766 56.79 154.927 62.5916C154.088 68.3931 150.505 73.7538 144.862 77.651C139.219 81.5483 131.911 83.7095 124.332 83.7223H39.4878C29.924 83.7297 20.6977 80.9999 13.6001 76.063C6.50256 71.126 2.04004 64.334 1.07888 57.0056C0.117726 49.6772 2.72651 42.3351 8.39879 36.4047C14.0711 30.4743 22.4022 26.3787 31.7748 24.913V24.3189C31.7699 21.1772 32.8435 18.0904 34.8868 15.3712C36.9301 12.6521 39.8704 10.3972 43.4098 8.83526C46.9492 7.2733 50.9618 6.45971 55.041 6.47695C59.1202 6.4942 63.121 7.34166 66.6379 8.93346C72.0502 4.81478 78.9288 2.02684 86.4013 0.923207C93.8738 -0.180422 101.604 0.44999 108.61 2.73449C115.617 5.01899 121.585 8.85465 125.757 13.755C129.929 18.6554 132.118 24.3996 132.045 30.2593C132.045 32.5166 131.736 34.6551 131.119 36.7936Z",
    fill: "#CDBFD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_157_134",
    x: 0.883545,
    y: 0.393799,
    width: 189.233,
    height: 118.329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_157_134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_157_134",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCloudIcon);
export default __webpack_public_path__ + "static/media/card_cloud_icon.db9aef943aaaf203859531b57d202021.svg";
export { ForwardRef as ReactComponent };